module.exports = __webpack_public_path__ + "media/images/vp/samples/17-6789d881f56599c065b8b819e11ded56.jpg";